{
  "pt": {
    "decision": {
      "actions": {
        "add": "Adicionar",
        "addDocument": "Adicionar documento",
        "addUnits": "Unidades",
        "approve": "Aprovar",
        "autoCloseAfterApproval": "Fecho automático após aprovação",
        "autoCloseAfterApprovalInfo": "A decisão fecha quando uma proposta é aprovada",
        "autoCloseAfterDeadline": "Fecho automático após o prazo",
        "cancel": "Anular",
        "changeResponsible": "Alterar responsável",
        "clickToSetDeadline": "Clique para definir o prazo",
        "closeDecision": "Fechar decisão",
        "confirmChoices": "Confirmar escolhas",
        "createProposal": "Criar proposta",
        "create_decisions": "Criar decisão | Criar decisões",
        "delete": "Eliminar",
        "deleteCount": "Está prestes a eliminar a decisão {count}. Tem a certeza? | Está prestes a eliminar as decisões de {count}. Tem a certeza?",
        "deleteMultipleDecisions": "Apagar...",
        "delete_cancel": "Cancelar",
        "delete_decisions": "Eliminar decisão | Eliminar decisões",
        "edit": "Editar",
        "editBudget": "Editar orçamento",
        "editDeadline": "Editar prazo",
        "editDecision": "Editar decisão",
        "editReminders": "Editar lembretes",
        "goToDecision": "Ir para a decisão",
        "goToProposal": "Ir para a proposta",
        "goToSummary": "Ir para o resumo",
        "hide": "Cancelar a publicação",
        "hideInfo": "Ocultar informações",
        "noDescription": "Clique para adicionar uma descrição",
        "openDecision": "Decisão em aberto",
        "publish": "Publicar",
        "publishAll": "Para todos",
        "publishCustomer": "Publicar para o cliente",
        "publishPartners": "Publicar para parceiro(s)",
        "reject": "Rejeitar",
        "relaunch_decision": "Decisão de relançamento",
        "request_changes": "Pedir alterações",
        "reset": "Reiniciar",
        "save": "Guardar",
        "save_and_share_partners": "Guardar e partilhar com parceiros",
        "selectAll": "Selecionar todas as unidades {total} ",
        "selectChoices": "Selecionar opções",
        "share_proposals": "Partilhar propostas",
        "showMoreInfo": "Mostrar mais informações",
        "stopApproving": "Deixar de aprovar",
        "submit": "Enviar",
        "tickBoxesDeletion": "Assinale as caixas de verificação dos ficheiros que pretende eliminar.",
        "unSelectAll": "Limpar seleção.",
        "unpublishForCustomer": "Cancelar a publicação para o cliente",
        "unpublishForPartners": "Cancelar publicação para parceiro de decisão",
        "update": "Atualização",
        "upload": "Carregar",
        "upload_documents": "Carregar documentos",
        "upload_proposals": "Carregar propostas"
      },
      "attributes": {
        "amount_gross": "Oferta bruta",
        "amount_net": "Oferta líquida",
        "approved_at": "Data de aprovação da proposta",
        "approved_proposal_name": "Proposta aprovada",
        "bathrooms": "Número de casas de banho",
        "bedrooms": "Número de quartos",
        "category": "Categoria",
        "customer_group_name": "Cliente",
        "decision_name": "Decisão",
        "decisions_count": "{count} decisão | {count} decisões",
        "due_date": "Prazo de entrega",
        "floor": "Armazém",
        "negative_surcharges_allowed": "Permitir crédito",
        "note_employee": "Nota",
        "price_budget": "Orçamento",
        "price_budget_extra": "Orçamento suplementar",
        "price_budget_info": "Pode sempre editar o orçamento mais tarde",
        "price_budget_info_mup": "Pode sempre editar o orçamento por unidade mais tarde",
        "price_margin": "Margem",
        "price_surcharge": "Atualização",
        "published": "Publicado",
        "responsible": "Responsável",
        "status": "Estado",
        "unit": "Unidade",
        "verification_type": "Decisão de aprovação adoptada por",
        "visibility": "Visibilidade"
      },
      "edit_actions": {
        "edit_auto_close": "Opções de fecho automático",
        "edit_close_decision": "Decisão Fechar/Abrir",
        "edit_deadline": "Definir prazo",
        "edit_margin": "Definir margens",
        "edit_negative_surcharges_allowed": "Permitir crédito",
        "edit_note_employee": "Editar nota",
        "edit_price_budget": "Definir orçamento",
        "edit_price_budget_extra": "Definir orçamento suplementar",
        "edit_reminders": "Definir lembretes",
        "edit_responsible": "Definir responsável"
      },
      "labels": {
        "accessRights": "Direitos de acesso",
        "activity": "Atividade",
        "addDecisionNote": "Adicionar nota",
        "addReminders": "Adicionar lembretes",
        "allUnits": "Todas as unidades",
        "allUnitsAssigned": "Todas as unidades atribuídas",
        "allow_not_interested": "Permitir opção 'Não interessado'",
        "allow_not_interested_cancel_warning": "Esta decisão está atualmente marcada como 'Não interessado'. Desativar esta opção cancelará o estado 'Não interessado'.",
        "allow_not_interested_info": "Mostra uma opção 'Não interessado' junto às propostas",
        "approved": "Aprovado",
        "approvedAt": "Aprovado {approved_at}",
        "approvedProposal": "Proposta aprovada",
        "askQuestion": "Coloque aqui as suas questões relativas à sua decisão {decision}",
        "assignCustomerToUnit": "Atribuir cliente",
        "autoClose": "Fecho automático",
        "budgetOverview": "Panorama orçamental",
        "budgetSubtitle": "Introduza aqui um orçamento se este se aplicar a todas as unidades seleccionadas ou adicione orçamentos mais tarde",
        "budgetTitle": "Definir um orçamento",
        "checkbox": "Caixa de verificação",
        "clickHereToChange": "Clique aqui se pretender alterá-las.",
        "close": "Fechar",
        "closeDecision": "Fechar decisão",
        "closed": "A decisão está encerrada para esta unidade. O cliente já não poderá aprovar uma proposta.",
        "closedLabel": "Decisão encerrada",
        "closed_tag": "Decisão encerrada",
        "closed_tooltip_customer": "A decisão está encerrada. Deixará de poder aprovar uma proposta.",
        "countDocuments": "Nenhum documento ainda | 1 documento | {count} documentos",
        "countEdit": "Editar a decisão da unidade {count} | Editar a decisão das unidades {count} ",
        "countUpload": "Carregar documento(s) para esta unidade | Carregar documento(s) para {count} unidades",
        "created_on": "Decisão criada em {date}",
        "custom_columns_title": "Pode adicionar até 10 colunas",
        "customer": "Cliente",
        "customer_status": "Estado do cliente",
        "decided": "Decidido",
        "decision": "Decisão",
        "decisionBreadcrumb": "Decisão {decision_type}",
        "decisionNotPublishedYetFor": "Decisão ainda não publicada para",
        "decisionNoteExplainer": "Esta nota só é visível para a sua equipa e para os parceiros que estão autorizados a ver esta decisão",
        "decisionType": "Decisão Assunto",
        "decisionUnit": "Decisão para a unidade {unit}",
        "decisions": "Decisões",
        "decisions_all_projects": "Decisões todos os projectos",
        "decisions_breadcrumb": "Decisões {project}",
        "default": "Predefinição",
        "deleteExplanation": "Todas as mensagens de comunicação, ficheiros, propostas e outros dados serão removidos permanentemente da plataforma. Os clientes e parceiros relacionados com estas decisões perderão todo o acesso.",
        "descriptionSubtitle": "Aqui pode adicionar mais informações para os seus clientes",
        "descriptionTitle": "Adicionar uma descrição para o seu cliente",
        "documentRequired": "Documento assinado necessário para a aprovação",
        "documentUnits": "Pasta da unidade",
        "documents": "Documentos de decisão",
        "dueDate": "Devido {date}",
        "due_date_subtitle": "Fixar uma data limite para a tomada de decisão",
        "due_date_title": "Prazo e lembretes",
        "editDecisionNote": "Editar nota",
        "extra_options": "Opções extra",
        "false": "Não",
        "filter": "Filtro",
        "finalSettings": "Algumas definições opcionais",
        "finalSettingsStep": "Definições finais",
        "financial": "Financeiro",
        "firstThingsfirst": "Antes de mais, algumas informações gerais",
        "follow": "Seguir",
        "following": "A seguir — receberá notificações",
        "four": "4",
        "giveNewAmount": "Dar em novo montante",
        "hideCount": "Anular a publicação desta decisão para 1 unidade | Anular a publicação da decisão para {count} unidades",
        "hideVisibilitySettings": "Ocultar definições de visibilidade",
        "indicate_not_interested": "Indicar que o cliente não está interessado nesta decisão",
        "info": "Mostrar mais informações",
        "infoCustomers": "Dados do cliente",
        "information": "Informações",
        "make_a_decision": "Tomar uma decisão",
        "marginOnBudget": "Margem sobre o orçamento (%)",
        "marginOnUpgrades": "Margem das actualizações (%)",
        "marginOnUpgradesExplainer": "A margem sobre as actualizações também será utilizada nos orçamentos adicionais que fornecer a um cliente. O orçamento extra pode ser definido na proposta.",
        "marginOverview": "Síntese das margens",
        "marginSubTitle": "Calcular margens automaticamente como percentagens",
        "marginTitle": "Utilizar percentagens de margem",
        "members": "Membros",
        "modifyLater": "Pode alterar estas definições mais tarde",
        "name": "Nome",
        "newActivity": "Nova atividade",
        "newDocument": "Novo(s) documento(s)",
        "next": "Seguinte",
        "no": "Não",
        "noApprovedProposalYet": "Nenhuma proposta aceite ainda",
        "noBudget": "Sem orçamento definido",
        "noCustomer": "Nenhum cliente ainda",
        "noCustomerAssigned": "Ainda não foi atribuído nenhum cliente à unidade",
        "noDeadline": "Sem prazo",
        "noDecisionDueDate": "Selecionar um prazo",
        "noDecisionStartDate": "Sem data de início definida",
        "noDecisionsMade": "Ainda não foram tomadas decisões",
        "noDecisionsToMake": "Não há decisões a tomar.",
        "noDecisionsYet": "Ainda não há decisões",
        "noDocumentsShared": "Nenhum documento partilhado",
        "noDueDate": "Defina primeiro um prazo antes de definir lembretes",
        "noDueDateSet": "Sem prazo definido",
        "noExtraBudget": "Sem orçamento suplementar",
        "noMessages": "Escreva a sua primeira mensagem para {decision} na caixa abaixo",
        "noUnitDocuments": "Ainda não foram adicionados documentos à pasta Unidade",
        "noUnitsClick": "Ainda não há unidades, clique aqui para adicionar",
        "no_result_for_search": "Nenhum resultado para esta pesquisa filtrada.",
        "no_surcharges": "Sem sobretaxas",
        "no_surcharges_info": "Propostas sem sobretaxas financeiras",
        "notDecided": "Ainda não decidido",
        "notDecidedYet": "O cliente ainda não tomou uma decisão.",
        "notFollowing": "Não segue — clique para receber notificações",
        "notPossibleToWriteMessageDeactivatedUnit": "Esta decisão está relacionada com uma unidade desactivada. Já não é possível escrever uma nova mensagem.",
        "notPublished": "Não publicado",
        "notPublishedCustomer": "Não publicado para o cliente",
        "notPublishedPartners": "Não publicado para parceiros de decisão",
        "notShared": "Não partilhado",
        "not_interested": "Não estou interessado",
        "not_interested_customer": "Não está interessado",
        "not_interested_customer_info": "Se não estiver interessado nesta decisão ou se esta decisão não for relevante para si, clique aqui para o indicar.",
        "not_interested_modal": {
          "customer": {
            "body": "Queira fornecer informações adicionais sobre os motivos pelos quais não está interessado nesta decisão",
            "title": "Não estou interessado nesta decisão"
          },
          "employee": {
            "body": "Forneça algum feedback adicional sobre a razão pela qual o cliente não está interessado nesta decisão. Este comentário também será visível para o cliente.",
            "title": "O cliente não está interessado nesta decisão"
          },
          "feedback": "Feedback"
        },
        "one": "1",
        "open": "Aberto",
        "openDecisionInfo": "Esta decisão está em aberto. O cliente pode aprovar propostas.",
        "open_auto_close_deadline_unit": "Defina se a decisão será encerrada automaticamente ou não quando o prazo for ultrapassado",
        "open_auto_close_unit": "Definir se a decisão será fechada automaticamente ou não após a aprovação ",
        "open_close_unit": "a decisão para 1 unidade | a decisão para {unit_count} unidades",
        "or": "ou",
        "participants": "Participantes",
        "partners": "Parceiros de decisão",
        "pendingDecisions": "1 decisão a tomar | {count} decisões a tomar",
        "priceBudget": "Orçamento",
        "priceBudgetExtra": "Orçamento extra",
        "proposal": "Propostas",
        "proposals": "Propostas | 1 proposta | {count} propostas",
        "publish?": "Guardar e publicar?",
        "publishNow?": "Publicar agora?",
        "publishTopOfPage": "Pode publicar esta decisão no topo desta página",
        "publishedCount": "Publicar esta decisão para 1 unidade | Publicar decisão para {count} unidades",
        "publishedCustomer": "Publicado para o cliente",
        "publishedCustomerPartners": "Publicado para clientes e parceiros de decisão",
        "publishedNone": "Ainda não publicado",
        "publishedPartners": "Publicado para parceiros de decisão",
        "publishedSince": "Publicado desde {date}",
        "published_info": "Mostra se todas as unidades foram publicadas para clientes e/ou parceiros de decisão",
        "remainOpen": "Manter-se aberto",
        "reminders": "Lembretes",
        "remindersCount": "1 lembrete | {count} lembretes",
        "reopenDecision": "Reabrir a decisão",
        "requiresDocumentVerification": "Exige documento assinado para aprovação",
        "requiresNoDocumentVerification": "Não é necessário um documento assinado para a aprovação",
        "returnToTickets": "Voltar atrás",
        "rights": {
          "access_full": "Acesso total",
          "access_none": "Acesso restrito",
          "access_semi": "Acesso básico",
          "customer_show": "É possível ver as informações do cliente.",
          "default": "Os parceiros de decisão podem enviar mensagens, carregar documentos e criar propostas para <b>{client_name}</b> em qualquer altura. Eles também têm acesso aos planos na pasta de documentos da unidade. Abaixo pode editar os seus direitos de comunicação com os seus clientes.",
          "document_customer": "Pode partilhar os seus documentos diretamente com o cliente.",
          "message_customer": "Pode enviar mensagens para o cliente.",
          "proposal_customer": "Podem partilhar as suas propostas diretamente com o cliente."
        },
        "save?": "Salvar?",
        "saveExplainer": "Tornar esta decisão visível para os seus clientes? Ou guardar e publicar mais tarde?",
        "select": "Selecionar",
        "selectOneUnit": "Selecionar pelo menos 1 unidade",
        "selectUnits": "Selecionar unidades",
        "select_units": "Selecionar unidades",
        "selected": "{selected} unidade selecionada. | {selected} unidades seleccionadas.",
        "sharedWith": "Partilhado com",
        "showDecisionsFor": "Mostrar decisões para",
        "show_all_units": "Mostrar todas as unidades",
        "signOnline": "Digite o nome para confirmar (predefinição)",
        "signUploadDocument": "Carregar documento assinado",
        "signedDocument": "Carregar documento assinado",
        "status": "Estado",
        "statusExplained": "O que significa cada estado de decisão?",
        "step2Subtitle": "Seleccione o seu projeto para incluir todas as suas unidades de uma só vez.",
        "step2Title": "Que unidades têm de tomar uma decisão?",
        "step2TitleWithDecisionName": "Que unidades têm de tomar uma decisão para {decision_name}?",
        "subject": "Assunto",
        "summary": "Resumo",
        "surcharge_tooltip": "Esta é a sobretaxa para esta decisão",
        "surcharges_total": "Actualizações: {total}",
        "surcharges_total_tooltip": "Esta é a quantidade total de actualizações para todas as unidades que têm uma atualização",
        "three": "3",
        "tickets": "Conversas sobre decisões",
        "toBeDecided": "A decidir",
        "toDecide": "Para decidir",
        "total": "Total",
        "totalSelected": "Todas as unidades {total} são seleccionadas.",
        "true": "Sim",
        "two": "2",
        "type": "Tipo",
        "unitDecisionsWillBeShownHere": "As decisões de unidade serão apresentadas aqui",
        "unitNotActivated": "Apenas para unidades activadas",
        "unitSelected": "Nenhuma unidade | Uma unidade | {count} unidades",
        "unit_name": "Unidade",
        "units": "Unidades",
        "unpublish": "Não publicado",
        "unpublished": "Não publicado",
        "uploadDocument": "Carregar documentos",
        "useMargins": "Ativar as percentagens de margem",
        "use_surcharges": "Usar sobretaxas",
        "use_surcharges_info": "Definir um orçamento para sobretaxas",
        "validation_errors": "Há problemas com esta proposta. Resolva-os primeiro e depois tente novamente.",
        "waitingForClient": "À espera do cliente",
        "whatTheCustomerHasBought": "O que o cliente comprou",
        "when": "Quando",
        "who": "Quem",
        "withAll": "Todos",
        "withClient": "Apenas com {client} ",
        "withCustomer": "Com o cliente",
        "withCustomerName": "Com {customer}",
        "withPartners": "Apenas com parceiros de decisão",
        "yes": "Sim"
      },
      "legend": {
        "all": "Todas as decisões",
        "approved": "Decidido",
        "approvedAfterDue": "Proposta aprovada fora do prazo",
        "created": "Nenhuma proposta ainda",
        "decisionApproved": "Proposta aprovada",
        "hasDecision": "Ainda não foi carregada nenhuma proposta",
        "hasProposal": "Proposta carregada",
        "has_proposal": "A decidir",
        "isExpired": "Prazo expirado, nenhuma proposta carregada",
        "isExpiredHasProposal": "Prazo expirado, proposta carregada",
        "noDecision": "Unidade excluída para esta decisão",
        "not_interested": "Não estou interessado nesta decisão",
        "other_decisions": "Outras decisões",
        "requested_changes": "Alterações solicitadas",
        "waiting_for_proposal": "À espera de proposta"
      },
      "navigation": {
        "backToDecisions": "Voltar às decisões"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Novas decisões serão tomadas em breve!",
            "title": "Prepare-se para tomar uma decisão"
          },
          "no_documents": {
            "subtitle": "Aqui encontra todos os documentos relacionados com esta decisão",
            "title": "Carregar documentos relacionados com a decisão {decision_name}"
          }
        },
        "employees": {
          "conversations": {
            "none": {
              "subtitle": "A partir do momento em que há um cliente atribuído a esta unidade, verá as conversas aqui",
              "title": "Aqui encontra todas as conversas para esta decisão"
            }
          },
          "new": {
            "subtitle": "Atribuir uma decisão a várias unidades de uma só vez",
            "title": "Criar a sua primeira decisão"
          }
        },
        "partners": {
          "none": {
            "subtitle": "Receberá uma notificação por correio eletrónico quando for publicada uma nova decisão.",
            "title": "Ainda não tem nenhuma decisão"
          }
        }
      },
      "toasts": {
        "bulk_create": "Decisão criada com sucesso | Decisões criadas com sucesso",
        "bulk_delete": "Decisão eliminada com êxito | Decisões eliminadas com êxito",
        "bulk_update": "Decisão actualizada com êxito | Decisões actualizadas com êxito",
        "update": "Decisão actualizada com sucesso"
      },
      "validation": {
        "amountRequired": "O montante é necessário",
        "cannotUpdatePrice": "O orçamento não pode ser editado, uma vez que as prestações baseadas nesta decisão foram tornadas visíveis para o cliente",
        "customer": {
          "need_not_interested_note": "Queira indicar as razões pelas quais não está interessado nesta decisão"
        },
        "employee": {
          "need_not_interested_note": "Dê a sua opinião sobre a razão pela qual o cliente não está interessado nesta decisão."
        },
        "installmentsSent": "Algumas decisões seleccionadas têm prestações visíveis para o cliente. O seu orçamento permanecerá o mesmo.",
        "mustBeZeroOrMore": "Deve ser 0 ou mais",
        "needAttachment": "Carregar pelo menos um novo documento ou selecionar um da pasta da unidade",
        "needNumber": "Necessita de um número (por exemplo, 8400.5)",
        "needTitle": "O título é obrigatório",
        "need_responsible": "Necessita de um responsável",
        "priceBudgetNotNegative": "O orçamento não pode ser um número negativo.",
        "responsibleRequired": "Responsável necessário",
        "selectContactPerson": "Selecionar pelo menos uma pessoa de contacto"
      }
    }
  }
}
